import dayjs from 'dayjs';

/**
 * An API instant as the profile's display date and a 24-hour time
 * (`DD/MM/YYYY HH:mm`), in the browser's zone.
 */
export const formatDisplayDateTime = (instant: string): string =>
    dayjs(instant).format('DD/MM/YYYY HH:mm');
